import { render, staticRenderFns } from "./GlobalNavBar.vue?vue&type=template&id=0658a1b2&scoped=true&"
import script from "./GlobalNavBar.vue?vue&type=script&lang=js&"
export * from "./GlobalNavBar.vue?vue&type=script&lang=js&"
import style0 from "./GlobalNavBar.vue?vue&type=style&index=0&id=0658a1b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0658a1b2",
  null
  
)

export default component.exports